import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { AuthProvider, oidcConfig, configure as configureOidc } from "@shadowhealth/oidc-login";
import App from "./App";

configureOidc({
  useFakeAuth: process.env.FAKE_AUTH === "true",
  oidcServerUri: globalThis.env.OIDC_SERVER_URL,
  oidcIssuerUri: globalThis.env.OIDC_ISSUER_URL,
  redirectUri: `${window.location.origin}/`,
  clientId: globalThis.env.OIDC_CLIENT_ID,
  // Keycloak client roles that may use ConvoVec (PROG-65578). Mirrors the
  // convovec-core check on protected_router.
  roleConfig: { role: ["viewer", "admin"] },
});

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(
  <Router>
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
    >
      <AuthProvider {...oidcConfig}>
        <App />
      </AuthProvider>
    </SnackbarProvider>
  </Router>,
);

if (import.meta.hot) import.meta.hot.accept();
